import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';

const styles = {
  card: {
    height:'100vh',
    maxWidth: '100vw',
  },
  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'contain',
    padding:'2%'
  },
};

const Popover =({open, handleClose, tileInfo, classes,popData}) => (
  <div>
  {console.log('id',popData)}
        <Dialog
          open={open}
          keepMounted
           maxWidth={'lg'}

          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
        <Card className={classes.card}>

              <CardMedia
                component="img"
                alt="Contemplative Reptile"
                className={classes.media}
                height='470'
                image={popData.img}
                title={popData.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  {popData.title}
                </Typography>
                <Typography component="p">
                  {popData.description}
                </Typography>
              </CardContent>

            {popData.url ?
              <CardActions>
              <a href={popData.url}>
                <Button size="small" color="primary" >
                  Learn More
                </Button>
              </a>
            </CardActions> 
             :null }
          </Card>
        </Dialog>
      </div>
);

// export default withStyles(styles)(Popover);
export default withStyles(styles)(Popover);
